import { formDataEncode } from "../util/form";
import { getClient } from "./base";

export const getRace = id => {
    return getClient().get(`api/competition/manager/race/${id}?${formDataEncode({ t: new Date().getTime() })}`);
};
